import { render, staticRenderFns } from "./PreviousAddressMovedInDate.vue?vue&type=template&id=f2b790ec"
import script from "./PreviousAddressMovedInDate.vue?vue&type=script&lang=js"
export * from "./PreviousAddressMovedInDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports